<template>
  <div>
    <nav class="nav-extended" style="margin-bottom: 1rem">
      <div class="nav-wrapper">
        <div class="row container">
          <b v-if="user" style="font-size: 2rem" class="center flow-text">
            SOLTAR TRACKER
          </b>
        </div>
      </div>
    </nav>
    <div class="container">
      <div>
        <div class="fixed-action-btn">
          <a @click="salir" class="btn-floating btn-large red">
            <i class="mdi mdi-logout mdi-36px"></i>
          </a>
        </div>

        <div class="row">
          <div class="col s12 m12" style="text-align: left">
            
              
            <h5 style="color: #3660aa">Hola, {{ user?.displayName }}</h5>
            <p style="font-size: 1.2rem; color: rgb(116, 115, 115)">
              {{ getSaludo() }}, ¿qué gestionaremos hoy?
            </p>
          </div>
        </div>

        <div class="row menu-container">
          <router-link to="/taller" v-show="permisos['taller']">
            <div class="col s12 m6">
              <div class="modulo waves-effect waves-light card-panel menu-card">
                <!-- <i class="mdi mdi-factory" style="font-size: 8rem"></i> -->
                <div>
                  <img src="@/assets/factory.png" style="width: 50%" alt="" />
                </div>

                <span style="" class="menu-title flow-text">
                  Taller
                </span>
              </div>
            </div>
          </router-link>
          <router-link to="/chofer" v-show="permisos['chofer']">
            <div class="col s12 m6">
              <div class="modulo waves-effect waves-light card-panel menu-card">
                <!-- <i class="mdi mdi-truck" style="font-size: 8rem"></i> -->
                <div>
                  <img src="@/assets/truck.png" style="width: 50%" alt="" />
                </div>
                <span style="" class="menu-title flow-text">
                  Chofer
                </span>
              </div>
            </div>
          </router-link>

          <router-link to="/almacen" v-show="permisos['almacen']">
            <div class="col s12 m6">
              <div class="modulo waves-effect waves-light card-panel menu-card">
                <!-- <i class="mdi mdi-store" style="font-size: 8rem"></i> -->
                <div>
                  <img src="@/assets/warehouse.png" style="width: 50%" alt="" />
                </div>
                <span style="" class="menu-title flow-text">
                  Almacén
                </span>
              </div>
            </div>
          </router-link>
          <router-link to="/logistica" v-show="permisos['logistica']">
            <div class="col s12 m6">
              <div class="modulo waves-effect waves-light card-panel menu-card">
                <!-- <i class="mdi mdi-clipboard-text" style="font-size: 8rem"></i> -->
                <div>
                  <img src="@/assets/reports.png" style="width: 50%" alt="" />
                </div>
                <span style="" class="menu-title flow-text">
                  Reportes
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <div class="footer-copyright">
      <div class="container" style="text-align: center; color: #3660aaaa">
        &copy; 2026 SOLTAR IMPRESORES S.A. DE C.V.
      </div>
    </div>
  </footer>
</template>
<style lang="css">
@media screen and (min-width: 1024px) {
  .menu-container {
    transform: scale(.5) translateY(-50%);
  }
  .menu-title {
    font-size: 2rem;
  }
}
.menu-card {
  display: grid;
  background-color: #ffffff;
  border-radius: 55px;
  box-shadow: 0 15px 35px rgba(54, 96, 170, 0.12),
    0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: none;
  cursor: pointer;
  margin: 1.05rem;
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}

.menu-card:hover {
  /* Al pasar el mouse, el botón "sube" y la sombra se expande */
  transform: translateY(-5px);
  box-shadow: 0 25px 50px rgba(54, 96, 170, 0.18),
    0 10px 20px rgba(0, 0, 0, 0.03);
}
/* .menu-card {
  background-color: #eeeeee;
  box-shadow: -5px -5px 13px 0px white, 5px 5px 13px 0px #00000050;

  display: grid;
  border-radius: 2rem;
}

.menu-card:hover {
  box-shadow: inset -5px -5px 13px 0px white, inset 5px 5px 13px 0px #00000050;
  background-color: #eeeeee;
  transform: scale(0.95);
}
.menu-item {
  margin: 0% 2% 0% 2% !important;

  display: inline-flex;
} */
</style>

<script>
// @ is an alias to /src
import firebase from "firebase/app";
export default {
  name: "Home",
  data() {
    return {
      permisos: {},
      user: undefined,
    };
  },
  methods: {
    getSaludo() {
      const hora = new Date().getHours();
      if (hora < 12) return "Buenos días";
      else if (hora < 18) return "Buenas tardes";
      else return "Buenas noches";
    },
    salir() {
      firebase.auth().signOut();
      this.$router.go("/login");
    },
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
      if (user) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            let claims = idTokenResult.claims;
            this.permisos = claims.permisos;
            this.$forceUpdate();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  },
};
</script>
